import { prop } from "vue-class-component";

import { IEstimatifClient } from "@/models/api";

export default class ParametresEstimatifClientProps {
    estimatifClient: IEstimatifClient = prop({
        required: true,
    });
}
